import api from '../../api'

import {
    SET_REALESTATE_MARKETSTUDIES,
    SET_TEMP_REALESTATE_MARKETSTUDIES,
    SET_APPRAISAL_MARKETSTUDIES
} from '../../constants'

const default_state = {
    marketstudies: {},
    temp_marketstudies: {}
}
const state = default_state

const {map} = require('p-iteration')

const _map = _.map





const actions = {
    FETCH_REALESTATE_MARKETSTUDIES: ({state, commit, rootState}, data) => {
        // console.log('data.path (fetch_realestate_marketstudies) ---->')
        // console.log(data.path)
        return api.get({path: data.path})
            .then((res) => {
                console.log(res)
                commit(SET_REALESTATE_MARKETSTUDIES, res)
            })
    },
    FETCH_TEMP_REALESTATE_MARKETSTUDIES: ({state, commit, rootState}, data) => {
        // console.log('data.path (fetch_realestate_marketstudies) ---->')
        // console.log(data.path)
        return api.get({path: data.path})
            .then((res) => {
                console.log(res)
                commit(SET_TEMP_REALESTATE_MARKETSTUDIES, res)
            })
    },
    COPY_COMPARABLES_FROM_MARKETSTUDY: ({state, commit, rootState}, data) => {
        // console.log('data.path (fetch_realestate_marketstudies) ---->')
        // console.log(data.path)
        return new Promise((resolve, reject) => {

            let arr_comparables =_map(data.comparables, (value, key) => ({
                key,
                ...value
            }))

            console.log('data.comparables: ')
            console.log(data.comparables)
            console.log('arr_comparables: ')
            console.log(arr_comparables)

            // constant "map" from the 'p-iteration' plugin
            map(arr_comparables, (value, index) => {
                return new Promise((resolve, reject) => {


                    api.get({path: 'marketstudy_ad_comparables' + '/' + data.temp_marketstudy_id + '/' + value.key})
                        .then((res) => {

                        let comparable = res
                            // console.log('waruuuaa res:')
                            // console.log(res)

                            // set the correct ids in the paths
                            //comparable['path'] = "realestate_marketstudies/" + data.marketstudy_id + '/'
                            comparable['path'] = "marketstudy_ad_comparables/" + data.marketstudy_id + '/'
                            comparable['parent_path'] = "realestate_marketstudies/" + data.realestate_id + "/" + data.marketstudy_id + "/" + "comparables" + "/"

                            api.set_value({
                                path: 'realestate_marketstudies' + '/' + data.realestate_id + '/' + data.marketstudy_id + '/' + 'comparables' + '/' + value.key,
                                value: true
                            })
                                .then((res) => {
                                    api.set_value({
                                        path: 'marketstudy_ad_comparables' + '/' + data.marketstudy_id + '/' + value.key,
                                        value: comparable
                                    })
                                        .then((res) => {
                                            // console.log(res)
                                            resolve()
                                        })
                                })

                        })
                })
            }).then((result) => {
                    resolve()

                })
        })

        /*
        _.forEach(data.comparables, function (value, key) {
            api.get({path: 'marketstudy_ad_comparables' + '/' + data.temp_marketstudy_id + '/' + key})
                .then((res) => {
                    console.log('waruuuaa res:')
                    console.log(res)
                    api.set_value({
                        path: 'realestate_marketstudies' + '/' + data.realestate_id + '/' + data.marketstudy_id + '/' + 'comparables' + '/' + key,
                        value: true
                    })
                        .then((res) => {
                            // console.log(res)
                        })
                    api.set_value({
                        path: 'marketstudy_ad_comparables' + '/' + data.marketstudy_id + '/' + key,
                        value: res
                    })
                        .then((res) => {
                            // console.log(res)
                        })
                })
        })
        */
    },

    FETCH_REALESTATE_MARKETSTUDIES_PARENT: ({state, commit, rootState}, data) => {
        // console.log('data.path (fetch_realestate_marketstudies) ---->')
        // console.log(data.path)
        return api.get({path: data.path})
            .then((res) => {
                console.log(res)
                let keys = []
                _.forEach(res, function (value, key) {
                    console.log('key!: ')
                    console.log(key)
                    keys.push(key)
                })

                console.log('*********!!!!!! keys: ')
                console.log(keys)
                commit(SET_APPRAISAL_MARKETSTUDIES, keys)
            })
    }
}

const mutations = {
    [SET_REALESTATE_MARKETSTUDIES] (state, data) {
        state.marketstudies = check_undefined(data)
    },
    [SET_TEMP_REALESTATE_MARKETSTUDIES] (state, data) {
        state.temp_marketstudies = check_undefined(data)
    },
    [SET_APPRAISAL_MARKETSTUDIES] (state, data) {
        state.app_marketstudies = check_undefined(data)
    }
}

const getters = {
    realestate_marketstudies: state => {
        return state.marketstudies
    },
    temp_marketstudies: state => {
        return state.temp_marketstudies
    },
    // short version (parent)
    appraisal_marketstudies: state => {
        return state.app_marketstudies
    }
}

function check_undefined (myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar
    } else {
        return null
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/realestate/realestate_marketstudies.js